import * as Common from '@/tenant/common';

export class Currency extends Common.MasterBase{
  constructor(){
    super('Currency');
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public code: string = '';
  public name: string = '';
  public mark: string = '';
  public precision: number = 0;
  public roundType: number = 0; //初期値は四捨五入

  public copy():any {
    const temp = super.copy() as Currency;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export class CurrencyQuery extends Common.LoadQuery {
  constructor(){
    super('CurrencyQuery',Currency);
    this.sort = 'code';
  }

  public code: string = '';
  public name: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class GetSystemCurrecy extends Common.Query {
  constructor(){
    super('GetSystemCurrecy',new Common.ModelBinder(Currency,false));
  }
}

export class GetBankAccount extends Common.Query {
  constructor(){
    super('GetBankAccount',new Common.ModelBinder(Common.BankAccount,false));
  }

  public currencyCode: string = '';
}

export class GetCurrencies extends Common.Query {
  constructor(){
    super('GetCurrencies', new Common.ModelBinder(Common.Currency,true));
  }
}